const variants = {
  "primary": {
    root: {
      backgroundColor: "black",
      color: "white",
    },
    container: {
      backgroundColor: "black",
      color: "white",
      border: 'none !important',
    },
    button: {
      backgroundColor: "black",
      color: "white",
      justifyContent: "space-between",
      textTransform: 'capitalize',
      _focus: {
        background: "#000 !important"
      },
      _hover: {
        background: "#000 !important"
      }
    },
    panel: {
      backgroundColor: "black",
      color: "white",
    },
    icon: {
      backgroundColor: "black",
      color: "white",
      marginRight: "2px"
    }
  },
  "secondary": {
    root: {
      backgroundColor: "black",
      color: "white",
    },
    container: {
      backgroundColor: "black",
      color: "white",
      border: 'none !important'
    },
    button: {
      backgroundColor: "black",
      color: "white",
      marginBottom: '0px !important',
      outline: 'none !important',
      textTransform: 'capitalize',
      border: 'none !important',
      borderBottom: '1px solid #fff !important',
      letterSpacing: '0px',
      _focus: {
        background: "#000 !important"
      },
      _hover: {
        background: "#000 !important"
      }
    },
    panel: {
      backgroundColor: "white",
      color: "black",
    },
    icon: {
      marginRight: "8px"
    }
  }
}

export const Accordion = {
  variants
}
